import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {ModalService} from "../../views/modal/base_modal.component";
import { TemplateService } from "../template.service";
import { UserService } from "../../user/user.service";

@Component({
	selector: 'template-template',
	template: `
		<div class="row">
			<div class="col-md-12">
				<cache-date></cache-date>
			</div>
			
			<div class="col-md-12">
				<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
			</div>
			
			<div class="col-md-12">
				<loading [isLoad]="statsLoader"></loading>
				
				<table class="table">
					<thead>
						<tr>
							<th>
								{{ 'adminstat.template.template' | translate }}
							</th>
	
							<th>
								{{ 'adminstat.common.siteCount' | translate }}
							</th>
	
							<th>
								
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let stat of stats; let i = index">
							<td>
								{{ stat.templateId }}
							</td>

							<td>
								{{ stat.count }}
							</td>
							
							<td>
								<ngb-accordion #acc="ngbAccordion">
									<ngb-panel
										[id]="'a' + i"
										title="{{ 'adminstat.common.site subjects' | translate }} ({{ stat.subjects.length }})"
									>
										<ng-template ngbPanelContent>
											<table class="table">
												<tbody>
													<tr *ngFor="let subject of stat.subjects">
														<td>
															{{ subject.subjectId }}
														</td>
								
														<td>
															{{ subject.count }}
														</td>
													</tr>
												</tbody>
											</table>
										</ng-template>
									</ngb-panel>
								</ngb-accordion>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

	`
})
export class TemplateComponent extends BaseComponent {
	stats = [];

	addFilterParams = {
		userType: 'user',
		isTemplateTag: true,
		dateFilters : ['dateTemplateTag', 'dateCreated', 'datePaid']
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public modalService: ModalService,
		public http: HttpClient,
		public helper: HelperService,
		public templateService: TemplateService,
		public userService: UserService
	) {
		super(eventsService, templateService, activatedRoute, filter, translate);
	}

	async getData() {
		console.log('1', 1)
		await this.getStats();
	}


	async getStats() {
		this.statsLoader = true;

		const { stats } = await this.templateService.template.stats(
			this.filter.filterParams
		).toPromise();
		this.stats = stats;

		this.statsLoader = false;
	}
}
